import { reloadOnceOnChunkLoadError } from '@/shared/lib/chunkLoadError';

reloadOnceOnChunkLoadError();
